import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";
import StickyMobileCTA from "@/components/layout/StickyMobileCTA";
import { Outlet, useLocation } from "react-router-dom";

export default function Layout() {
    const { pathname } = useLocation();
    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="bg-background text-white min-h-screen flex flex-col">
            <Header />
            <main className="flex-1 pt-20 pb-20 lg:pb-0">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppFloat />
            <StickyMobileCTA />
        </div>
    );
}
